// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"42":"38ee3a41","154":"5d5cd4cd","516":"4b07b9cd"}[chunkId] + ".css";
};